import { z } from 'zod';

import { codec, useQueryParams } from '@/hooks/router/use-query-params';

export function useSiteMapFilters() {
  return useQueryParams({
    siteIds: {
      key: 'site_ids',
      codec: codec.array(codec.string),
      schema: z.array(z.string()).optional(),
    },
  });
}
